import { API_ROUTES } from "./apiRoutes";
import api from "./axiosInstance";
import axios from "axios";

// 🔹 Login
export const authUser = async (data) => {
  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}${API_ROUTES.AUTH.LOGIN}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
};

// 🔹 Forgot password
export const forgotPasswordApi = async (data) => {
  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}${API_ROUTES.AUTH.FORGOT_PASSWORD}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
};

// 🔹 Reset password
export const resetPasswordApi = async (data) => {
  const { _id, ...rest } = data;
  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}${API_ROUTES.AUTH.RESET_PASSWORD(
      _id
    )}`,
    rest,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
};

// 🔹 Get user details
export const getUserDetails = async (data) => {
  const res = await api.post(API_ROUTES.AUTH.DETAILS, data);
  return res.data;
};

// 🔹 Fetch all users (with query params)
export const fetchUsers = async (data) => {
  const res = await api.get(API_ROUTES.USER.LIST, {
    params: { ...data },
  });
  return res.data;
};

// 🔹 Create user
export const createUser = async (userData) => {
  const res = await api.post(API_ROUTES.USER.CREATE, userData);
  return res.data;
};

// 🔹 Edit user
export const editUser = async (userData) => {
  const { _id, ...payload } = userData;
  const res = await api.put(API_ROUTES.USER.EDIT(_id), payload);
  return res.data;
};

// 🔹 Delete user
export const deleteUser = async (userData) => {
  const { _id } = userData;
  const res = await api.delete(API_ROUTES.USER.DELETE(_id));
  return res.data;
};

// 🔹 role

export const getRoleList = async (data) => {
  const res = await api.get(API_ROUTES.USER.ROLE, {
    params: { ...data },
  });
  return res.data;
};

export const mediaUpload = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}${API_ROUTES.USER.MEDIA}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};
